import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f0db8a7e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0db8a7e')) {
      api.createRecord('f0db8a7e', component.options)
    } else {
      api.reload('f0db8a7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f0db8a7e&", function () {
      api.rerender('f0db8a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/users/index.vue"
export default component.exports